/**
* Use the CSS tab above to style your Element's container.
*/
import React from 'react'
import { useStripe, useElements, IbanElement } from '@stripe/react-stripe-js'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'
import messages from 'i18n/messages'

const IBAN_ELEMENT_OPTIONS = {
  style: {
    base: {
      width: '100%',
      display: 'block',
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
  supportedCountries: ['SEPA'],
}

function IbanSection({ org, setStatus, customer, clientSecret, paymentMethod }) {
  
  const stripe = useStripe()

  const hostname = `${window.location.protocol}//${window.location.host}`
  const return_url = `${hostname}/${org.odn}/status`

  const paymentMethods = {
    eps: () => stripe.confirmEpsPayment(
            clientSecret,
            {
              payment_method: {
                billing_details: {
                  name: `${customer.firstname} ${customer.lastname}`,
                }
              },
              return_url,
            }
          ),
    giropay: () => stripe.confirmGiropayPayment(
            clientSecret,
            {
              payment_method: {
                billing_details: {
                  name: `${customer.firstname} ${customer.lastname}`,
                }
              },
              return_url,
            }
          )
  }

  const handleSubmit = async (event) => {
    setStatus({ loading: true })
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault()

    if (!stripe) return

    const result = await paymentMethods[paymentMethod]()

    if (result.error) {
      setStatus({ status: 'error', error: result.error.message, loading: false })
    }
    if (result.paymentIntent) {
      setStatus({ status: result.paymentIntent.status, loading: false, error: null })
    }
  }

  return (
    <form onSubmit={handleSubmit} className={classNames('d-flex justify-content-center', { loading: status.loading })} style={{ width: '100%'}}>
      <button className="btn btn-primary btn-rounded block">
        <FormattedMessage {...messages.proceedToDirectTransferPSP} />
      </button>
    </form>
  )
}

export default IbanSection